import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasParentProductId } from "@insite/client-framework/Components/ParentProductContext";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ProductFeatureComponent from "@WhiteCap/Components/ProductFeatureComponent";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    title = "title",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
    };
}

export interface ProductDetailsFeatureStyles {
    specificationTittle: InjectableCss;
}

export const productDetailsFeatureStyles: ProductDetailsFeatureStyles = {
    specificationTittle: {
        css: css`
            border-bottom: 0.2rem solid #fc3;
            box-sizing: border-box;
            display: inline-flex;
            font-weight: 600;
            color: #474747;
            font-size: 24px;
            text-transform: uppercase;
        `,
    },
};
const styles = productDetailsFeatureStyles;

type Props = OwnProps & ReturnType<typeof mapStateToProps> & HasParentProductId & HasProduct;
const mapStateToProps = (state: ApplicationState, ownProps: HasParentProductId) => ({});

const ProductDetailsFeature: React.FC<Props> = ({ product, fields }) => {
    if (!product) {
        return null;
    }
    const syndigoDiv = document.getElementById('syndi_inline');
    
    return (
        <StyledWrapper>
            {syndigoDiv?.childNodes.length !== 0 && syndigoDiv?.childNodes.length !== undefined ?<StyledWrapper>
        <Typography {...styles.specificationTittle}>
           {fields.title ? fields.title : "PRODUCT FEATURES"}
        </Typography>
      </StyledWrapper> : null}
         <ProductFeatureComponent syndigoId={product.productNumber}></ProductFeatureComponent>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(connect(mapStateToProps)(ProductDetailsFeature)),
    definition: {
        displayName: "Product Details Feature",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Title ",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
                sortOrder: 0,
            },
        ],
    },
};

export default widgetModule;

